// @ts-ignore
import { GandalfArray } from 'gandalf';
// @ts-ignore
import { GandalfConstantDecorator } from 'gandalf';
// @ts-ignore
import { GandalfLabel } from 'gandalf';
// @ts-ignore
import { GandalfModel } from 'gandalf';
// @ts-ignore
import { GandalfModelBase } from 'gandalf';
// @ts-ignore
import { GandalfProperty } from 'gandalf';
// @ts-ignore
import { GandalfSubRequestLabel } from 'gandalf';
// @ts-ignore
import { GandalfValidator } from 'gandalf';
// @ts-ignore
import * as constants from '../constants';


// @ts-ignore
import { PatientFileInfoResponse } from './patient-file-info-response';

/** See com.rev360.pms.api.controller.insurance.IntakeInsuranceListResponse */
/* istanbul ignore next */
@GandalfModel
export class IntakeInsuranceListResponse extends GandalfModelBase {

	@GandalfProperty({ designType: String })
	insuranceCompanyName!: string | null;

	@GandalfProperty({ designType: Number })
	intakeInsuranceId!: number | null;

	@GandalfProperty({ designType: PatientFileInfoResponse })
	patientFileInfoResponse!: PatientFileInfoResponse | null;

	@GandalfProperty({ designType: Number })
	personInsuranceId!: number | null;

	@GandalfProperty({ designType: String })
	policyHolder!: string | null;

	@GandalfProperty({ propertyType: 'LocalDate', designType: Date })
	policyHolderDob!: Date | null;

	@GandalfConstantDecorator(constants.PolicyHolderRelationship)
	@GandalfProperty({ designType: constants.PolicyHolderRelationship })
	policyHolderRelationship!: constants.PolicyHolderRelationship | null;

	@GandalfProperty({ designType: String })
	policyNumber!: string | null;

	@GandalfProperty({ designType: Number })
	practiceInsuranceCompanyId!: number | null;

	@GandalfConstantDecorator(constants.IntakeReconciledStatus)
	@GandalfProperty({ designType: constants.IntakeReconciledStatus })
	reconciledStatus!: constants.IntakeReconciledStatus | null;

	@GandalfConstantDecorator(constants.IntakeStatus)
	@GandalfProperty({ designType: constants.IntakeStatus })
	status!: constants.IntakeStatus | null;

}
